import { Box, Text } from "@chakra-ui/react";
import { Card } from "../../components/Card";
import * as React from "react";

export const mapEmissionsPerYearData = (apiData) => {
  if (apiData) {
    return apiData
      .filter(el => el.revenue && typeof el.revenue !== "undefined")
      .map(el => {
        return {
          year: el.year,
          "Scope 1": el.revenue.scope1TotalCo2Emissions ?? 0,
          "Scope 2": el.revenue.scope2TotalCo2Emissions ?? 0,
          "Scope 3": el.revenue.scope3TotalCo2Emissions ?? 0,
          total: el.totalCo2Emissions
        };
      });
  }
  return [];
};

export const mapScopeAssociatedEmissionsChartData = (apiData) => {
  const scopeObjects = [
    {
      key: "scope1ApportionedCo2Emissions",
      index: 1,
      color: "hsla(50,100%,50%,0.49)"
    },
    {
      key: "scope2ApportionedCo2Emissions",
      index: 2,
      color: "hsla(0,100%,50%,0.62)"
    },
    {
      key: "scope3ApportionedCo2Emissions",
      index: 3,
      color: "hsla(212,100%,50%,0.75)"
    }
  ];
  const mappedData = [];

  if (apiData) {
    scopeObjects.forEach(obj => {
      if (apiData[obj.key] && typeof apiData[obj.key] !== "undefined" && apiData[obj.key] > 0) {
        mappedData.push({
          id: obj.index,
          label: `Scope ${obj.index}`,
          value: apiData[obj.key],
          color: obj.color
        });
      }
    });
  }

  return mappedData;
};

export const getScopeAssociatedEmissionsChartTooltip = (tooltipObj) => {
  const { datum: { data } } = tooltipObj;
  const formattedValue = data.value && data.value > 0 ?
    data.value.toLocaleString("en-GB", { maximumFractionDigits: 4 }) : "";

  return (
    <Box position="relative">
      <Card
        position="absolute"
        minWidth={"250px"}
        padding={3}
        right={"100%"}
      >
        <Text fontSize="sm">
          {data.label} - <b>{formattedValue}</b> tCO<sub>2e</sub>
        </Text>
      </Card>
    </Box>);
};